import React from 'react';
import { IoLocationOutline, IoCallOutline, IoStorefrontOutline } from 'react-icons/io5';

const PartnerPlaceItemContainer = ({ partnerPlace, onSelect }) => {
    const handleClick = () => {
        if (onSelect) {
            onSelect({
                name: partnerPlace.name,
                address: partnerPlace.address,
                phone: partnerPlace.phone,
                latitude: partnerPlace.latitude,
                longitude: partnerPlace.longitude,
                isPartner: true,
                partnerId: partnerPlace.id
            });
        }
    };

    const formatDistance = (distance) => {
        if (distance < 1) {
            return `${Math.round(distance * 1000)}m`;
        }
        return `${distance.toFixed(1)}km`;
    };

    return (
        <button
            onClick={handleClick}
            className="w-full p-4 bg-white border border-gray-200 rounded-lg active:bg-gray-50 transition-colors text-left"
        >
            <div className="flex items-start space-x-3">
                {/* 이미지 */}
                <div className="flex-shrink-0 w-16 h-16 bg-gray-100 rounded-lg overflow-hidden">
                    {partnerPlace.imageUrl ? (
                        <img
                            src={partnerPlace.imageUrl}
                            alt={partnerPlace.name}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center">
                            <IoStorefrontOutline size={24} className="text-gray-400" />
                        </div>
                    )}
                </div>

                {/* 정보 */}
                <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between mb-1">
                        <h3 className="text-sm font-semibold text-gray-900 truncate pr-2">
                            {partnerPlace.name}
                        </h3>
                        <span className="flex-shrink-0 text-xs text-blue-600 font-medium">
                            나에게서 {formatDistance(partnerPlace.distance)}
                        </span>
                    </div>

                    <div className="space-y-1">
                        <div className="flex items-center text-xs text-gray-600">
                            <IoLocationOutline size={12} className="mr-1 flex-shrink-0" />
                            <span className="truncate">{partnerPlace.address}</span>
                        </div>

                        {partnerPlace.phone && (
                            <div className="flex items-center text-xs text-gray-600">
                                <IoCallOutline size={12} className="mr-1 flex-shrink-0" />
                                <span>{partnerPlace.phone}</span>
                            </div>
                        )}
                    </div>

                    {/* 제휴 혜택 정보 */}
                    {partnerPlace.policy && (
                        <div className="mt-2 p-2 bg-blue-50 rounded text-xs text-blue-800">
                            <span className="line-clamp-2">{partnerPlace.policy}</span>
                        </div>
                    )}
                </div>
            </div>
        </button>
    );
};

export default PartnerPlaceItemContainer;
